import { type GasPayload } from '@atlaskit/analytics-gas-types';

import type { NonPrivacySafeAttributes } from '../../events/types';

interface QuickFindThirdPartyLinkShownProps {
	commonAttributes: Record<string, any>;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
}

export const onThirdPartyLinkShown = ({
	commonAttributes,
	nonPrivacySafeAttributes,
}: QuickFindThirdPartyLinkShownProps): GasPayload => ({
	eventType: 'ui',
	action: 'shown',
	actionSubject: 'thirdPartyLink',
	attributes: {
		experienceName: 'quick-find',
		...commonAttributes,
	},
	nonPrivacySafeAttributes,
});
